/**
 * Keeps in-page anchor links (the header nav's #the-story, #how-it-works,
 * #faqs) from scrolling a section's top edge underneath the sticky
 * header. Measures the header's actual rendered height - rather than
 * hardcoding one - since it varies by breakpoint (the tablet/mobile row
 * vs. the desktop row) and by whatever logo size a merchant configures,
 * and sets that as the page's scroll-padding-top so every anchor jump
 * (and scroll-behavior: smooth, set in critical.css) leaves the right
 * amount of clearance automatically.
 */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;

  function updateOffset() {
    document.documentElement.style.scrollPaddingTop = header.getBoundingClientRect().height + 'px';
  }

  updateOffset();
  window.addEventListener('resize', updateOffset);

  if (window.ResizeObserver) {
    new ResizeObserver(updateOffset).observe(header);
  }
})();
